<template>
  <div class="template-default d-flex flex-column">
    <!-- <div id="animation"></div> -->

    <header>
      <div class="backdrop-filter"></div>
      <div class="content d-flex align-items-center container-fluid">
        <router-link :to="{ name: 'home' }" class="brand">
          <img src="@/assets/images/logo-m60-white.svg" />
        </router-link>

        <desktop-menu class="flex-fill" />
        <div class="d-lg-none flex-fill"></div>

        <div
          id="search-notifications-profile"
          class="d-flex align-items-center"
        >
          <search />
          <calendar />
          <notifications />
          <profile-dropdown @logout="logoutDialog = true" />
        </div>
      </div>
    </header>

    <confirmation
      v-model="logoutDialog"
      @confirm="logout"
      text="Tem certeza que deseja sair?"
      confirm-button-text="Sair"
    />

    <action-dispatcher
      action="courses/getAll"
      :parameters="{ limit: 100 }"
      class="flex-fill"
      @error="logout"
    >
      <main class="flex-fill">
        <div class="position-relative slot-wrapper">
          <action-dispatcher
            action="user/get"
            @success="successUser"
            @error="logout"
          >
            <slot />
          </action-dispatcher>
        </div>
      </main>
    </action-dispatcher>

    <app-footer @logout="logoutDialog = true" />

    <terms-modal v-if="termsDialog" @close="termsDialog = false" />
    <complement-modal
      v-else-if="complementDialog"
      @close="complementDialog = false"
    />
    <b-modal
      v-else-if="popupDialog"
      v-model="popupDialog"
      hide-footer
      hide-header
      centered
    >
      <pop-up :messages="messages" @close="popupDialog = false" />
    </b-modal>
  </div>
</template>

<script>
import AppFooter from "@/components/templates/AppFooter";
import DesktopMenu from "@/components/templates/DesktopMenu";
import PopUp from "@/components/templates/PopUp";
import ProfileDropdown from "@/components/templates/ProfileDropdown";
import { mapState } from "vuex";
import ComplementModal from "@/components/templates/ComplementModal";
import TermsModal from "@/components/templates/TermsModal";
import Notifications from "@/components/templates/Notifications";
import Calendar from "@/components/templates/Calendar";
import get from "lodash/get";
import Search from "../components/templates/Search.vue";

export default {
  components: {
    ProfileDropdown,
    AppFooter,
    PopUp,
    DesktopMenu,
    ComplementModal,
    TermsModal,
    Notifications,
    Calendar,
    Search
  },
  data() {
    return {
      popupDialog: false,
      logoutDialog: false,
      complementDialog: false,
      termsDialog: false,
      menuButtonTimeout: null,
      showIframeChat: false
    };
  },
  computed: {
    ...mapState(["loading"]),
    ...mapState("user", ["messages"])
  },
  mounted() {
    this.$store.dispatch("user/getMessages").then(data => {
      this.popupDialog = !!data.length;
    });
  },
  methods: {
    successUser() {
      if (this.$user.user && !this.$user.user.is_enable) {
        this.$router.replace({ name: "sale" });
      }
      this.termsDialog = !get(this.$user, "user.is_terms_accepted");
      this.complementDialog = !get(this.$user, "user.complement");
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push({ name: "login" });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.template-default {
  min-height: 100vh;
  display: flex;
  position: relative;

  .blocking-bg {
    position: fixed;
    z-index: 3;
    background: rgba(0, 10, 20, 0.5);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  i {
    font-size: 24px;
    min-width: 46px;
  }

  main {
    width: 100%;
    position: relative;
  }

  header {
    min-height: 81px;
    max-height: 81px;
    width: 100%;
    top: 0;
    flex: 1 1 auto;
    position: fixed;
    z-index: 3;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.75) -8%,
      rgba(0, 0, 0, 0.55) 25%,
      rgba(0, 0, 0, 0.4) 50%,
      rgba(0, 0, 0, 0.2) 76%,
      rgba(0, 0, 0, 0.1) 88%,
      rgba(0, 0, 0, 0) 101%
    );
    z-index: 5;

    .backdrop-filter {
      backdrop-filter: blur(2px);
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }

    .content {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1;
    }

    @media screen and (max-width: 767px) {
      padding: 0 16px;
    }

    ::v-deep .btn {
      color: white;
      font-size: 12px;
      padding-left: 0;
      padding-right: 0;
      min-width: 32px;

      @media screen and (max-width: 991px) {
        font-size: 10px;
        min-width: 28px;
      }
    }

    .brand {
      img {
        max-height: 30px;
        @media screen and (max-width: 991px) {
          max-height: 20px;
        }
      }
    }

    i {
      font-size: 20px;
    }
  }

  .slot-wrapper {
    transition: 0.3s padding ease;
  }

  .backdrop {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .desktop-profile-dropdown {
    width: 72px;
    height: 72px;
    z-index: 10;
    // position: fixed !important;
    top: 16px;
    left: 16px;
  }

  .btn-menu {
    width: 81px;
    height: 81px;
    z-index: 10;
    position: fixed !important;

    i {
      min-width: 46px;
      font-size: 32px;
      line-height: 44px;
    }
  }

  .chat-bot {
    min-height: 80vh;
    max-width: 500px;
    position: fixed;
    right: 20px;
    bottom: 80px;

    @media (max-width: 991px) {
      min-height: 50vh;
      max-width: 85vw !important;
    }
  }

  .floating-wpp {
    position: fixed;
    bottom: 20px;
    right: 20px;
    display: inline-flex;
    align-items: center;
    color: white;
    background: linear-gradient(180deg, #00e6bc 0%, #00a396 100%);
    border-radius: 100px;
    z-index: 2;
    border: none;

    &:hover {
      filter: brightness(120%);
    }

    strong {
      display: none;
    }

    img {
      max-width: 56px;
      max-height: 56px;
      min-width: 56px;
      min-height: 56px;
    }
  }
  #search-notifications-profile {
    @media screen and (min-width: 992px) {
      gap: 8px;
    }
  }
}
</style>
